import type { JSX } from 'react';
import { Button } from '@mui/material';

export function ParkingPortalButton({
    onClick,
    disabled,
    children,
    icon,
}: {
    onClick: () => void;
    disabled: boolean;
    children: JSX.Element;
    icon?: JSX.Element;
}) {
    return (
        <Button
            sx={theme => ({
                display: 'flex',
                flex: 1,
                color: theme.palette.white.main,
                backgroundColor: theme.palette.primary.main,
                padding: theme.spacing(3),
                fontSize: '16px',
                justifyContent: 'space-between',
                '&.Mui-disabled': {
                    color: theme.palette.grey['500'],
                    backgroundColor: theme.palette.grey['300'],
                },
            })}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
            {icon}
        </Button>
    );
}
